import { render } from "./ProcessComponent.vue?vue&type=template&id=5ea9f089&scoped=true"
import script from "./ProcessComponent.vue?vue&type=script&lang=js"
export * from "./ProcessComponent.vue?vue&type=script&lang=js"

import "./ProcessComponent.vue?vue&type=style&index=0&id=5ea9f089&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ea9f089"]])

export default __exports__